import { SegmentType } from '@gn-audio/core/common/enums';
import { TranslationKey } from 'src/Foundation/Translation/platform';
import { assertNever } from '../utils/assert-never';

export const getComingSoonDictionaryKey = (segmentType?: SegmentType): TranslationKey | undefined => {
  switch (segmentType) {
    case SegmentType.Business:
      return TranslationKey.ContactSales;
    case SegmentType.Consumer:
      return TranslationKey.KeepMeUpdated;
    case SegmentType.Convergence:
    case SegmentType.Unknown:
      return undefined;
    default:
      return assertNever(segmentType as never);
  }
};
